import type { ForwardedRef, MutableRefObject, Ref } from 'react';

export function composeRefs<T extends HTMLElement>(opts: {
  innerRef: MutableRefObject<T | null>;
  forwardedRef: ForwardedRef<T | null>;
}): Ref<T> {
  const { innerRef, forwardedRef } = opts;
  return function (node) {
    innerRef.current = node;
    if (typeof forwardedRef === 'function') {
      forwardedRef(node);
    } else if (forwardedRef) {
      forwardedRef.current = node;
    }
  };
}
